import { ColoursObj } from '@eventr/common-storybook'
import { InlineElements } from './InlineElements'
import { DateTime } from 'luxon'
import { useLanguageContext } from '../../../../state/languageState/languageContext'

export const ParagraphBlock = ({ contents, messageDate }) => {
    return (
        <p
            style={{
                display: 'inline-block',
                margin: '0',
                textAlign: 'left',
                wordBreak: 'break-word',
                position: 'relative',
            }}
        >
            <InlineElements contents={contents} />
            <span
                style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    fontWeight: '400',
                    color: ColoursObj.font.primary,
                    paddingLeft: '8px',
                    paddingTop: '8px',
                    float: 'right',
                }}
            >
                {DateTime.fromJSDate(messageDate).toFormat(
                    useLanguageContext.getState().timeFormat,
                    {
                        locale: useLanguageContext
                            .getState()
                            .getLanguageISO639Code(),
                    }
                )}
            </span>
        </p>
    )
}
